/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjectFeFleet,
    ReadOnlyMonitoredObjectFeFleetFromJSON,
    ReadOnlyMonitoredObjectFeFleetFromJSONTyped,
    ReadOnlyMonitoredObjectFeFleetToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20031
 */
export interface InlineResponse20031 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20031
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20031
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20031
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObjectFeFleet>}
     * @memberof InlineResponse20031
     */
    results: Array<ReadOnlyMonitoredObjectFeFleet>;
}

export function InlineResponse20031FromJSON(json: any): InlineResponse20031 {
    return InlineResponse20031FromJSONTyped(json, false);
}

export function InlineResponse20031FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20031 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjectFeFleetFromJSON)),
    };
}

export function InlineResponse20031ToJSON(value?: InlineResponse20031 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjectFeFleetToJSON)),
    };
}


